import type { C1_FurnitureDefinition, C1_FurnitureRendererProps } from "../../types/C1_FurnitureTypes";
import { RoomType } from "../../types/C1_ModelTypes";
import { C1_FurnitureSvg } from "../C1_FurnitureSvg";
import { C1_FurnitureIcon } from "../C1_FurnitureIcon";

const DEFAULT_WIDTH = 1.0;
const DEFAULT_HEIGHT = 2.0;

const SingleBed: C1_FurnitureDefinition = {
  id: "singleBed",
  icon: <C1_FurnitureIcon kind="single-bed" />,
  description: { en: "Single bed", de: "Einzelbett" },
  category: RoomType.Bedroom,
  defaultWidth: DEFAULT_WIDTH,
  defaultHeight: DEFAULT_HEIGHT,
  autoReflect: true,
  allowManualReflect: true,
  properties: [],
  Renderer: ({
    width,
    height,
    rotation,
    PX,
    strokeWidth,
    strokeColor,
    fillColor,
    showDetails,
  }: C1_FurnitureRendererProps) => {
    const finalRotation = rotation ?? 0;
    const finalStrokeWidth = strokeWidth ?? 2;
    const finalStrokeColor = strokeColor ?? "#000000";
    const finalFillColor = fillColor ?? "#ffffff";
    const inset = 0.02 * PX;

    return (
      <C1_FurnitureSvg
        PX={PX}
        width={width}
        height={height}
        rotation={finalRotation}
        viewBoxWidth={width}
        viewBoxHeight={height}
        originXPercentage={0}
        originYPercentage={0}
      >
        <rect
          x={inset}
          y={inset}
          width={Math.max(0, width - inset * 2)}
          height={Math.max(0, height - inset * 2)}
          rx={0.03 * PX}
          fill={finalFillColor}
          stroke={finalStrokeColor}
          strokeWidth={finalStrokeWidth * 2}
        />
        <rect
          x={0.08 * PX}
          y={0.08 * PX}
          width={Math.max(0, width - 0.16 * PX)}
          height={Math.max(0, height - 0.16 * PX)}
          rx={0.03 * PX}
          fill={finalFillColor}
          stroke={finalStrokeColor}
          strokeWidth={finalStrokeWidth}
        />
        {showDetails && (
          <>
            <rect
              x={width * 0.18}
              y={0.16 * PX}
              width={width * 0.64}
              height={Math.min(0.24 * PX, height * 0.2)}
              rx={0.06 * PX}
              fill={finalFillColor}
              stroke={finalStrokeColor}
              strokeWidth={finalStrokeWidth}
            />
            <path
              d={`M ${0.08 * PX} ${Math.min(0.48 * PX, height * 0.3)} Q ${width / 2} ${Math.min(0.62 * PX, height * 0.38)} ${width - 0.08 * PX} ${Math.min(0.48 * PX, height * 0.3)} L ${width - 0.08 * PX} ${height - 0.08 * PX} L ${0.08 * PX} ${height - 0.08 * PX} Z`}
              fill="none"
              stroke={finalStrokeColor}
              strokeWidth={finalStrokeWidth}
            />
          </>
        )}
      </C1_FurnitureSvg>
    );
  },
};

export default SingleBed;
